import { useContext, useMemo } from 'react';
import { MultiStepFormContext } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';
import CheckList from 'components/CheckList';
import FormPage from 'pages/ApplyForFinance/FormPage';
import ApplyForm from 'pages/ApplyForFinance/FormPage/ApplyForm';
import { scrollToTop } from 'utils';

import Header from './Header';
import { LIST_TITLE, LIST_TITLE_PROPS, LIST } from './constants';
import { formatTradingName } from './Welcome-functions';

const Welcome = () => {
  const {
    data: { job, provider, isLoading },
  } = useContext(MultiStepFormContext);

  const tradingName = formatTradingName(job);

  const isExampleJob = job?.flow_type === 'example';

  const listProps = useMemo(() => {
    if (provider === 'etika' && !isExampleJob) return LIST.etika;
    return LIST.default;
  }, [provider, isExampleJob]);

  const listTitle = useMemo(() => {
    if (provider === 'etika' && !isExampleJob)
      return LIST_TITLE.replace('$MIN', '3');
    return LIST_TITLE.replace('$MIN', '5');
  }, [provider, isExampleJob]);

  return (
    <ApplyForm>
      <FormPage
        nextButtonProps={{
          onClick: scrollToTop,
          disabled: isLoading,
          isLoading,
        }}
      >
        <Header
          provider={provider as string}
          tradingName={tradingName}
          isLoading={isLoading}
          isExampleJob={isExampleJob}
        />
        <Text {...LIST_TITLE_PROPS} text={listTitle} isLoading={isLoading} />
        <CheckList {...listProps.list} isLoading={isLoading} />
      </FormPage>
    </ApplyForm>
  );
};

Welcome.displayName = 'ApplyForFinance-Desktop-Pages-Welcome';

export default Welcome;
